<template>
  <div class="retail_pagination p_0 ml_15">
    <!-- <p class="pr_10">
      {{ pagination.current_page }}-{{ pagination.to }} off
      {{ pagination.total }}
    </p>
    <ul>
      <li>
        <a id="prevPage" :class="{ disabled: pageData.current_page == 1 }">
          <template v-if="pageData.current_page == 1">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-4 h-4 mr-[1px] lg:w-5 lg:h-5 lg:mr-[2px]"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M15.75 19.5 8.25 12l7.5-7.5"
              ></path>
            </svg>
          </template>
          <div v-else @click="changePage(Number(pageData.current_page) - 1)">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-4 h-4 mr-[1px] lg:w-5 lg:h-5 lg:mr-[2px]"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M15.75 19.5 8.25 12l7.5-7.5"
              ></path>
            </svg>
          </div>
        </a>
      </li>

      <li>
        <a
          id="nextPage"
          :class="{ disabled: pageData.current_page === pageData.last_page }"
        >
          <template v-if="pageData.current_page === pageData.last_page">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-4 h-4 ml-[1px] lg:w-5 lg:h-5 lg:ml-[2px]"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="m8.25 4.5 7.5 7.5-7.5 7.5"
              ></path>
            </svg>
          </template>
          <div v-else @click="changePage(Number(pageData.current_page) + 1)">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-4 h-4 ml-[1px] lg:w-5 lg:h-5 lg:ml-[2px]"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="m8.25 4.5 7.5 7.5-7.5 7.5"
              ></path>
            </svg>
          </div>
        </a>
      </li>
    </ul> -->
    <slot name="table_collapse"></slot>
  </div>
</template>

<script>
export default {
  name: 'TopPaginationComponent',
  props: {
    pagination: {
      type: Object,
      required: false,
    },
  },
  computed: {
    pagesNumber() {
      var pagesArray = [];

      var start = Math.max(1, this.pageData.current_page - 1);
      var end = Math.min(
        this.pageData.current_page + 1,
        this.pageData.last_page
      );

      if (this.pageData.current_page == 1) {
        start = 1;
        end = Math.min(3, this.pageData.last_page);
      }
      if (this.pageData.current_page == 2) {
        start = 1;
        end = Math.min(3, this.pageData.last_page);
      }
      if (
        this.pageData.current_page >= 2 &&
        this.pageData.current_page <= this.pageData.last_page - 1
      ) {
        start = Number(this.pageData.current_page) - 1;
        end = Number(this.pageData.current_page) + 1;
      }
      if (this.pageData.current_page == this.pageData.last_page - 1) {
        start = Math.max(this.pageData.last_page - 2, 1);
        end = this.pageData.last_page;
      }
      if (this.pageData.current_page >= this.pageData.last_page) {
        start = Math.max(this.pageData.last_page - 2, 1);
        end = this.pageData.last_page;
      }
      for (var i = start; i <= end; i++) {
        pagesArray.push(i);
      }
      return pagesArray;
    },
    showPagination() {
      if (this.pagination && this.pagination.total > 10) {
        return true;
      } else {
        return false;
      }
    },
  },
  data() {
    return {
      pageData: { ...this.pagination },
      page: this.pagination ? this.pagination.current_page : 0,
    };
  },
  watch: {
    pagination: {
      deep: true,
      handler() {
        this.pageData = { ...this.pagination };
        this.page = this.pagination ? this.pagination.current_page : 0;
      },
    },
  },
  methods: {
    changePage(page) {
      this.pageData.current_page = page;
      this.page = page;
      this.$emit('pageChanged', page);
    },
  },
};
</script>
